export default [
  {
    path: "/authorise",
    name: "authorise",
    meta: { title: "SSO" },
    component: () => import("../views/sso/authorise.vue")
  }
]